// import { useContext } from "react"; // useContext was defined but never used

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme, useMediaQuery } from "@mui/material"; // Import hooks
// import AppContext from "./AppContext"; // AppContext was defined but never used

function Home() {
  // const { user } = useContext<any>(AppContext); // user was assigned a value but never used
  const theme = useTheme();
  // Check if the screen is small (down from 'sm' breakpoint)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // Define responsive sizes
  const iconSize = isSmallScreen ? "80px" : "150px"; // Use px for image height
  const logoSize = isSmallScreen ? "35px" : "50px"; // Use px for image height
  const titleVariant = isSmallScreen ? "h5" : "h3";
  const subtitleVariant = isSmallScreen ? "h6" : "h4";
  const footerTextVariant = isSmallScreen ? "caption" : "body1";


  return (
    // Main container using CSS Grid
    <Box
      sx={{
        display: 'grid',
        gridTemplateRows: '1fr auto',
        height: "100%",
        background: "white",
        width: '100%'
      }}
    >
      {/* Grid Area 1: Main Content */}
      <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'auto',
            p: 2 // Add some padding
        }}
      >
        {/* Content Stack - Adjusts direction and alignment based on screen size */}
        <Stack
            // Use responsive direction: column on xs, row on sm+
            direction={isSmallScreen ? 'column' : 'row'}
            // Center items when column, keep center vertically when row
            alignItems="center"
            // Adjust spacing based on direction
            spacing={isSmallScreen ? 2 : 3}
            sx={{ textAlign: isSmallScreen ? 'center' : 'left' }} // Center text when stacked
        >
          <Box // Wrap image in Box for better control if needed
             component="img"
             src="/icon.png"
             alt="Quantum Analytics Bot Icon"
             sx={{ height: iconSize, width: iconSize }} // Apply responsive size
           />
          {/* Text Stack */}
          <Stack spacing={1} > {/* Consistent spacing */}
            <Typography variant={titleVariant} component="h1"> {/* Responsive variant */}
                Quantum Analytics Bot
            </Typography>
            <Typography variant={subtitleVariant} component="h2"> {/* Responsive variant */}
                Accurate Answers from your Knowledge Base
            </Typography>
          </Stack>
        </Stack>
      </Box>

      {/* Grid Area 2: Footer */}
      <Box
        sx={{
             display: 'flex',
             justifyContent: "flex-end",
             padding: theme.spacing(1, 2), // Use theme spacing for padding
             alignItems: "center",
        }}
      >
        <Typography variant={footerTextVariant} color={"text.secondary"} sx={{ mr: 1 }}> {/* Responsive variant, theme color */}
          Powered by
        </Typography>
        <a href="https://quantumanalytics.ch/" target="_blank" rel="noopener noreferrer">
           <Box // Wrap image in Box
             component="img"
             src="/q-logo.png"
             alt="Quantum Analytics Logo"
             sx={{ height: logoSize, verticalAlign: 'middle' }} // Responsive size
           />
        </a>
      </Box>
    </Box>
  );
}

export default Home;